// extracted by mini-css-extract-plugin
module.exports = {"label":"_1eGt_rkBQBb4sGCNyWUqtd","toBeImplemented":"_1AEcqTmGvw4Rflks7vEig","selected":"_2Yz17hFKEioWr9IALYTGEa"};